import { default as baseService } from './base/index';
import { default as emailOTPService } from "./emailOTP/index";
import { default as accountService } from "./account/index";
import { default as transferService } from "./transfer/index";
import { default as studentIdService } from "./sthdentId/index";
import { default as adminService } from "./admin/index";
export {
    baseService,
    emailOTPService,
    accountService,
    transferService,
    studentIdService,
    adminService,
};
